export default __webpack_public_path__ + "6e5b252b09fbd8cbd91650c9264af89c.png";